export default __webpack_public_path__ + "static/Plots0107-8db5edfcbe9171e8fa29d81570ff710c.jpg";